"use client";

import { useState, useSyncExternalStore } from "react";

const LOCATIONS = [
  "\uD83C\uDDEB\uD83C\uDDF7 Meribel",
  "\uD83C\uDDE8\uD83C\uDDED Verbier",
  "\uD83C\uDDE6\uD83C\uDDF9 St Anton",
  "\uD83C\uDDE8\uD83C\uDDE6 Whistler",
  "\uD83C\uDDEF\uD83C\uDDF5 Niseko",
  "\uD83C\uDDEC\uD83C\uDDF7 Greece",
  "\uD83C\uDDEA\uD83C\uDDF8 Mallorca",
  "\uD83C\uDDFB\uD83C\uDDEC BVI",
  "\uD83C\uDDF3\uD83C\uDDFF Queenstown",
  "\uD83C\uDDE6\uD83C\uDDFA Byron Bay",
  "\uD83C\uDDEB\uD83C\uDDF7 Courchevel",
  "\uD83C\uDDEB\uD83C\uDDF7 Chamonix",
  "\uD83C\uDDE8\uD83C\uDDED Zermatt",
  "\uD83C\uDDEE\uD83C\uDDF9 Sardinia",
  "\uD83C\uDDED\uD83C\uDDF7 Croatia",
  "\uD83C\uDDF9\uD83C\uDDF7 Turkey",
  "\uD83C\uDDFA\uD83C\uDDF8 Aspen",
  "\uD83C\uDDE6\uD83C\uDDF7 Patagonia",
  "\uD83C\uDDF5\uD83C\uDDF9 Algarve",
  "\uD83C\uDDEE\uD83C\uDDE9 Bali",
  "\uD83C\uDDF2\uD83C\uDDFD Cabo",
  "\uD83C\uDDEC\uD83C\uDDE7 Glastonbury",
  "\uD83C\uDDE7\uD83C\uDDEA Tomorrowland",
];

const pillClass =
  "text-xs font-medium text-text-muted px-3 py-1.5 rounded-full border border-border-light bg-white whitespace-nowrap shrink-0";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function subscribeReducedMotion(cb: () => void) {
  const mq = window.matchMedia(REDUCED_MOTION_QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

function getReducedMotion() {
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

function getReducedMotionServer() {
  return false;
}

export function LocationTicker() {
  const reducedMotion = useSyncExternalStore(
    subscribeReducedMotion,
    getReducedMotion,
    getReducedMotionServer,
  );
  const [paused, setPaused] = useState(false);

  if (reducedMotion) {
    return (
      <div className="flex flex-wrap justify-center gap-2 max-w-4xl mx-auto px-6 md:px-12">
        {LOCATIONS.map((loc) => (
          <span key={loc} className={pillClass}>
            {loc}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className="relative overflow-hidden"
      style={{
        maskImage:
          "linear-gradient(to right, transparent, black 40px, black calc(100% - 40px), transparent)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent, black 40px, black calc(100% - 40px), transparent)",
      }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
    >
      <div
        className="flex gap-2.5 w-max"
        style={{
          animation: "ticker-scroll 60s linear infinite",
          animationPlayState: paused ? "paused" : "running",
        }}
      >
        {[0, 1].map((copy) => (
          <div key={copy} className="flex gap-2.5 shrink-0">
            {LOCATIONS.map((loc) => (
              <span key={`${loc}-${copy}`} className={pillClass}>
                {loc}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
